export const linkStart = 'link::';
export const linkEnd = '::link';
export const boldStart = 'bold::';
export const boldEnd = '::bold';
